export const SET_LOCALE = 'SET_LOCALE'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_REFRESHED_TOKEN = 'SET_REFRESHED_TOKEN'

export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS'
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS'
export const SET_OFFLINE = 'SET_OFFLINE'

export const UNSET_ACCOUNT = 'UNSET_ACCOUNT'

export const LOCALE_COOKIE = 'aloc'
export const ACCOUNT_COOKIE = 'cacc'

export const SET_BREADCRUMB = 'SET_BREADCRUMB'

export const SET_SETTINGS = 'SET_SETTINGS'

export const SET_USER_STATUS = 'SET_USER_STATUS'

export const SET_ALLOW_NAVIGATION = 'SET_ALLOW_NAVIGATION'
